import React, { useState, useEffect } from 'react';
import { Transition, Form, Icon, Button } from 'semantic-ui-react';
import CamposReuniao from './CamposReuniao';
import { SecaoForm, AreaArquivo, AvisoForm, RodapeForm } from '../../layouts/FormUI';
import * as FormValidator from '../../../utils/formValidator';
import api from '../../../api';
import { formatDocumento } from "../../../utils/formatador";

const EditarVotacaoSobre = ({ visible, loadingVotacao, condominio, votacao, votacaoPossuiVoto, updateVotacao }) => {
  const [responsaveis, setResponsaveis] = useState([]);
  const [convocacao, setConvocacao] = useState(null);
  const [formState, setFormState] = useState({ presidente: '0', secretario: '0', ...votacao });
  const [loading, setLoading] = useState({ votacao: loadingVotacao, responsavel: true, documento: false });
  const [sucesso, setSucesso] = useState({ votacao: false, convocacao: false });
  const [errors, setErrors] = useState({});

  useEffect(
    () => {
      if (condominio && condominio._id) {
        loadResponsaveis();
      }
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [condominio]
  );

  useEffect(() => {
    setLoading(p => ({ ...p, votacao: loadingVotacao }));
    setFormState(p => ({
      ...p,
      ...votacao,
      presidente: votacao.presidente || '0',
      secretario: votacao.secretario || '0',
    }));
  }, [loadingVotacao, votacao]);

  const loadResponsaveis = async () => {
    try {
      setResponsaveis(await api.responsavel.find(condominio._id).then(it => it.responsaveis));
      setLoading(p => ({ ...p, responsavel: false }));
    } catch (e) {
      setErrors((e.data && e.data.errors) || {});
    }
  };

  const closeMessage = (_, { name }) => setSucesso(p => ({ ...p, [name]: false }));

  const existeDoc = () => !!formState.documentoConvocacao && formState.documentoConvocacao.url;

  const getResponsaveis = label => [
    { key: '0', value: '0', text: `Selecione o ${label}` },
    ...responsaveis.map(it => ({
      key: it._id,
      value: it._id,
      text: `${it.nome} - ${formatDocumento(it.documento)}`
    }))
  ];

  const onChangeFile = e => {
    if (e.target.files && e.target.files[0] && e.target.files[0].type === 'application/pdf') {
      if (FormValidator.sizeLimit(e.target.files[0], process.env.REACT_APP_LIMIT_UPLOAD)) {
        setConvocacao(e.target.files[0]);
        setErrors({});
      } else {
        setErrors({ documentoConvocacao: `Permitido arquivos de até ${process.env.REACT_APP_LIMIT_UPLOAD}mb` });
      }
    }
  };

  const changeFormState = (name, value) => {
    setFormState(p => ({ ...p, [name]: value }));
    setErrors({});
  }

  const onChange = e => changeFormState(e.target.name, e.target.value);
  const onChangeSelect = (_, { name, value }) => changeFormState(name, value);

  const onSubmitDocumento = async () => {
    if (convocacao) {
      setLoading(p => ({ ...p, documento: true }));

      const formData = new FormData();

      formData.append('field', 'documentoConvocacao');
      formData.append('condominio', condominio._id);
      formData.append('arquivo', convocacao);

      try {
        const documentoConvocacao = await api.votacao.atualizarDocumento(votacao._id, formData);

        setFormState(p => ({ ...p, documentoConvocacao }));
        setLoading(p => ({ ...p, documento: false }));
        setSucesso(p => ({ ...p, convocacao: true }));
        setConvocacao(null);
      } catch (e) {
        setErrors((e.data && e.data.errors) || {});
      }
    } else {
      setErrors({ documentoConvocacao: 'Selecione um arquivo PDF' });
    }
  };

  const onSubmitDados = async e => {
    e.preventDefault();

    const errs = validate();
    setErrors(errs);

    if (Object.keys(errs).length === 0) {
      setLoading(p => ({ ...p, votacao: true }));

      try {
        const result = await api.votacao.updateSobre(votacao._id, { condominio: condominio._id, ...formState });
        updateVotacao(result);
        setLoading(p => ({ ...p, votacao: false }));
        setSucesso(p => ({ ...p, votacao: true }));
      } catch (e) {
        setErrors((e.data && e.data.errors) || {});
      }
    }
  };

  const validate = () => {
    const err = {};

    if (FormValidator.isVazio(formState.titulo)) {
      err.titulo = "Titulo é obrigatório";
    }

    if (FormValidator.isVazio(formState.dataInicioReuniao)) {
      err.dataInicioReuniao = "Data início é obrigatório";
    } else if (!FormValidator.isDataVotacao(formState.dataInicioReuniao) && !formState._id) {
      err.dataInicioReuniao = "Digite uma data maior ou igual a data atual";
    }

    if (FormValidator.isVazio(formState.dataFinalReuniao)) {
      err.dataFinalReuniao = "Data limite é obrigatório";
    } else if (!FormValidator.isDataVotacao(formState.dataFinalReuniao) && !formState._id) {
      err.dataFinalReuniao = "Digite uma data maior ou igual a data atual";
    }

    if (!FormValidator.isVazio(formState.urlTransmissao) && !FormValidator.isUrl(formState.urlTransmissao)) {
      err.urlTransmissao = "Digite uma url válida";
    }

    return err;
  };

  return (
    <Transition animation="fade up" duration={{ show: 700, hide: 0 }} visible={visible} transitionOnMount={true}>
      <div>
        {votacaoPossuiVoto && (
          <AvisoForm tipo="atencao" icone="warning sign">
            <b>Esta votação já possui votos.</b> Redobre a atenção ao atualizar os dados.
          </AvisoForm>
        )}
        {sucesso.votacao && (
          <div className="va-res-banner sucesso" role="status">
            <Icon name="check circle outline" size="big" />
            <div>
              <b>Dados alterados com sucesso</b>
              <div className="va-res-acoes">
                <Button size="small" basic name="votacao" onClick={closeMessage}>Fechar</Button>
              </div>
            </div>
          </div>
        )}
        <Form loading={loading.votacao || loading.responsavel} autoComplete="off" className="va-imp" onSubmit={onSubmitDados}>
          <SecaoForm icone="file pdf outline" titulo="Documento de convocação" descricao="O PDF que os moradores consultam no aplicativo.">
            {sucesso.convocacao && <AvisoForm tipo="ok" icone="check circle">Documento alterado com sucesso!</AvisoForm>}
            <AreaArquivo
              id="documentoConvocacao"
              arquivo={convocacao}
              accept="application/pdf"
              onChange={onChangeFile}
              titulo={existeDoc() ? 'Clique para trocar o documento' : 'Arraste o PDF aqui ou clique para selecionar'}
              dica={`Somente PDF · até ${process.env.REACT_APP_LIMIT_UPLOAD}mb`}
              erro={errors.documentoConvocacao}
              existenteUrl={existeDoc() ? formState.documentoConvocacao.url : null}
              existenteTexto="Ver documento atual"
              onConfirmar={onSubmitDocumento}
              confirmando={loading.documento}
            />
          </SecaoForm>

          <CamposReuniao
            valores={formState}
            errors={errors}
            onChange={onChange}
            onChangeSelect={onChangeSelect}
            getResponsaveis={getResponsaveis}
          />

          <RodapeForm>
            <Button type="submit" loading={loading.votacao || loading.responsavel} disabled={loading.votacao || loading.responsavel} className="btn-ui-1" size="large">
              <Icon name="save" /> Salvar alterações
            </Button>
          </RodapeForm>
        </Form>
      </div>
    </Transition>
  );
};

export default EditarVotacaoSobre;
